import { Badge } from "@/components/ui/badge";

// A job's code metrics (internal/compiler plans/2026-10-12-code-metrics.md).
// Work units are internal-only and never shown to customers.

export const LINES_OF_CODE_TOOLTIP =
  "Statements and declarations in every JS/TS file your build loaded (your code and its dependencies), before tree shaking. Comments, blank lines and type-only code don't count.";
export const COMPILED_LINES_TOOLTIP =
  "Lines of code left after tree shaking removed unused code, plus constant eval / new Function code compiled ahead of time.";
export const DYNAMIC_CODE_TOOLTIP_YES =
  "Your program needs dynamic code at run time (eval, new Function, vm or a dynamic require), so the interpreter was included in the binary.";
export const DYNAMIC_CODE_TOOLTIP_NO =
  "Everything was compiled ahead of time; the interpreter was not included in the binary.";

/** Thousands-separated count, or an em dash when unknown. */
export function fmtLines(n: number | null | undefined): string {
  return n == null ? "—" : n.toLocaleString("en-US");
}

/** "Dynamic code: yes/no" as a badge with an explanatory tooltip. */
export function DynamicCodeBadge({ value }: { value: boolean | null }) {
  if (value === null) return <span className="text-muted-foreground">—</span>;
  return (
    <Badge
      variant={value ? "warning" : "secondary"}
      title={value ? DYNAMIC_CODE_TOOLTIP_YES : DYNAMIC_CODE_TOOLTIP_NO}
      className="cursor-help"
    >
      {value ? "yes" : "no"}
    </Badge>
  );
}
